import script from "./QuickReplyComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./QuickReplyComponent.vue?vue&type=script&lang=ts&setup=true"

import "./QuickReplyComponent.vue?vue&type=style&index=0&id=1e39410e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e39410e"]])

export default __exports__